export * from './types';
// shared/i18n/index.ts
const dictionaryCache: Record<string, any> = {};

export interface GenericErrorType {
  [key: string]: string;
}

export function getDictErrorMessage(errors: unknown, errorMessageKey: string): string {
  const errorsDict = errors as Record<string, string>; // Cast temporaneo
  return errorsDict[errorMessageKey] || errorsDict['generic_error'] || 'Errore sconosciuto';
}

export const getModuleDictionary = async (locale: string, module: string) => {
  const normalizedLocale = locale || 'it';
  const cacheKey = `${normalizedLocale}-${module}`;

  if (dictionaryCache[cacheKey]) {
    return dictionaryCache[cacheKey];
  }

  try {
    const dictionary = await import(`./${normalizedLocale}/${module}.json`);
    dictionaryCache[cacheKey] = dictionary.default;

    // // Aggiungi qui il log per verificare il contenuto del dizionario caricato
    // console.log(`Dizionario caricato (${normalizedLocale}/${module}):`, dictionary.default);

    return dictionary.default;
  } catch (error) {
    console.error(`Errore nel caricamento del dizionario: ${normalizedLocale}/${module}.json`);
    console.error(error);
    return {}; // Fallback a un dizionario vuoto per evitare undefined
  }
};

const commonModule = 'common';

export const getCommonDictionary = async (locale: string) => {
  return getModuleDictionary(locale, commonModule);
};

// src/shared/i18n/index.ts
export function getLocale(params: { lang?: string }): string {
  return params.lang || 'it'; // Usa 'it' come fallback se `lang` è assente
}
